import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { IconButton, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { AutoTag } from './AutoTag';
import { RemoveAll } from './RemoveAll';
import { VerifyAll } from './VerifyAll';
import { AddMetadataMenu } from '../AddMetadataMenu/AddMetadataMenu';
import { useDocumentMetadata } from '../DocumentMetadataProvider';
export function MetadataActions() {
    const [confirmationModal, setConfirmationModal] = useState(undefined);
    const { activeEntries, data, documentId } = useDocumentMetadata();
    const { properties } = data;
    const pairsToVerify = properties.filter(({ pair }) => pair.needsVerification);
    const displayVerifyAllAction = Boolean(pairsToVerify.length);
    const displayRemoveAll = () => {
        setConfirmationModal('remove');
    };
    const displayVerifyAll = () => {
        setConfirmationModal('verify');
    };
    const close = () => setConfirmationModal(undefined);
    return (<Fragment>
      <AddMetadataMenu documentId={documentId}/>
      <AutoTag />
      <Menu.Root target={<IconButton size="xs" appearance="secondary" aria-label={t({
                message: 'Additional actions',
                comment: 'Metadata list actions: Show more',
            })}>
            <Falcon icon="ellipsis-vertical"/>
          </IconButton>}>
        {displayVerifyAllAction && (<Menu.Item onClick={displayVerifyAll} disabled={!activeEntries.length}>
            <Falcon icon="shield-check"/>
            <Trans comment="Metadata: Verify all metadata pairs">Verify all tags</Trans>
          </Menu.Item>)}
        <Menu.Item onClick={displayRemoveAll} disabled={!activeEntries.length}>
          <Falcon icon="trash"/>
          <Trans comment="Metadata: Remove all metadata pairs">Remove all</Trans>
        </Menu.Item>
      </Menu.Root>

      <RemoveAll open={confirmationModal === 'remove'} close={close}/>
      <VerifyAll open={confirmationModal === 'verify'} close={close}/>
    </Fragment>);
}
